<template>
  <div>
    <input
      ref="video"
      type="file"
      accept="video/*"
      @change="Video()"
      class="d-none"
    />
    <v-btn
      icon
      :disabled="
        !Editing || (LastQuestion ? LastQuestion.type === 'quickReply' : false)
      "
      @click="$refs.video.click()"
    >
      <v-icon>videocam</v-icon>
    </v-btn>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  props: ["questioninfo", "Editing", "LastQuestion"],
  methods: {
    Video() {
      for (const key in this.$refs.video.files) {
        if (Object.hasOwnProperty.call(this.$refs.video.files, key)) {
          const element = this.$refs.video.files[key];
          if (
            /\.(ogm|wmv|mpg|webm|ogv|mov|asx|mpeg|mp4|m4v|avi)$/i.test(
              element.name
            )
          ) {
            let videomb = element.size / 1000000;
            if (videomb <= 25) {
              let formData = new FormData();
              formData.append("fileMax", 25);
              formData.append("fileData", element);
              formData.append(
                "filePath",
                `survey/video/${this.$route.params.surveyID}-${this.questioninfo.questionType}/question/`
              );
              formData.append(
                "fileName",
                `${Date.now()}-${this.questioninfo.questionType}-`
              );
              this.$store.commit("ToggleLoading");
              this.$store
                .dispatch("UploadFormData", formData)
                .then((req) => {
                  this.$emit("sendvideo", req.data);
                  this.$store.commit("ToggleLoading");
                })
                .catch(() => {
                  this.$store.commit("ToggleLoading");
                });
            } else {
              Swal.fire({
                icon: "error",
                title: "ขนาดวิดีโอเกินกว่าที่กำหนด",
                text: "กรุณา upload วิดีโอไม่เกิน 25 mb",
                showCancelButton: false,
                showConfirmButton: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                allowEnterKey: false,
                confirmButtonColor: "#0093cc",
                confirmButtonText: "ตกลง",
              });
            }
          } else {
            Swal.fire({
              icon: "error",
              title: "กรุณา upload แต่วิดีโอเท่านั้น",
              text: `รองรับ ogm, wmv, mpg, webm, ogv, mov, asx, mpeg, mp4, m4v, avi`,
              showCancelButton: false,
              showConfirmButton: true,
              allowOutsideClick: false,
              allowEscapeKey: false,
              allowEnterKey: false,
              confirmButtonColor: "#0093cc",
              confirmButtonText: "ตกลง",
            }).then(() => {
              this.$refs.video.type = "text";
              this.$refs.video.type = "file";
            });
          }
        }
      }
      this.$refs.video.type = "text";
      this.$refs.video.type = "file";
    },
  },
};
</script>
